import { z } from "zod";

export const localityType = z.enum(["office", "airport"]);
export type LocalityType = z.infer<typeof localityType>;
